import React from "react";
import { DONATE_URL, DONATE_ENABLED, trackDonateClick } from "./donate";

interface Props {
  // Where the click came from (for analytics + slightly different styling).
  source: "nav" | "match-over";
  label?: string;
  // Leading glyph before the label. Defaults to a heart; the donate CTAs use
  // it to sell the "coffee → kebab" running gag.
  icon?: string;
  // Extra classes (e.g. the match-over CTA variant).
  className?: string;
}

// External donate link — opens the hosted donation page in a new tab. Renders
// nothing until DONATE_URL is configured, so we never show a broken link.
export default function DonateButton({ source, label = "Buy us a coffee", icon = "☕", className }: Props) {
  if (!DONATE_ENABLED) return null;
  // In the nav, share the .app-nav-link box (padding/radius/hover) so it lines up
  // with Help/Settings — keeps the divider equidistant from the two link groups.
  const navClass = source === "nav" ? " app-nav-link" : "";
  return (
    <a
      className={"app-donate" + navClass + (className ? " " + className : "")}
      href={DONATE_URL}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => trackDonateClick(source)}
    >
      <span className="app-donate-heart" aria-hidden="true">{icon}</span>
      {label}
    </a>
  );
}
